import React from "react";

export default function EditOpinionPostForm({
  t,
  formState,
  setCaption,
  disabled,
}) {
  return (
    <div className="edit-post-form-section">
      <label className="edit-post-field edit-post-field-wide">
        <span>{t("opinion_caption")}:</span>
        <textarea
          value={formState.caption}
          onChange={(event) => setCaption(event.target.value)}
          placeholder={t("opinion_caption_placeholder")}
          disabled={disabled}
          rows={5}
        />
      </label>
    </div>
  );
}
